import { GtmEvents } from '@/gtm/gtm-events';

export class SubscriptionsGtmEvents extends GtmEvents {
  constructor() {
    super('СобытияОбщие');
  }

  controlSubscriptionsVisible() {
    return this.gtmEvent({
      eventAction: 'Общее_PopUPПодписаться_Показ',
    });
  }

  controlSubscriptionsSuccess() {
    return this.gtmEvent({
      eventAction: 'Общее_PopUPПодписаться_Подписаться',
    });
  }

  controlSubscriptionsReject() {
    return this.gtmEvent({
      eventAction: 'Общее_PopUPПодписаться_ОтказПодписаться',
    });
  }

  controlSubscriptionsCrossClick() {
    return this.gtmEvent({
      eventAction: 'Общее_PopUPПодписаться_Крестик',
    });
  }
}

export const subscriptionsGtmEvents = new SubscriptionsGtmEvents();
